import { PAGES } from './shared/routes.constants'
export default [
  {
    path: 'home',
    component: require('./pages/home/index.page.vue')
  },
  {
    path: 'custom-page/:id',
    component: require('./pages/custom-page.vue')
  },
  {
    path: 'meet-the-team',
    component: require('./pages/meet-the-team/meet-the-team.vue')
  },
  {
    path: 'company-video',
    component: require('./pages/company-video.vue')
  },
  {
    path: 'meet-the-team/:id',
    component: require('./pages/meet-the-team/teammate.vue')
  },
  {
    path: 'brochures',
    component: require('./pages/brochures.vue')
  },
  {
    path: `${PAGES.TermAndConditions}`,
    component: require('./pages/terms.vue')
  },
  {
    path: `${PAGES.PrivacyPolicy}`,
    component: require('./pages/policy.vue')
  },
  {
    path: 'about',
    component: require('./pages/about/about.vue')
  },
  {
    path: 'video-message',
    component: require('./pages/video-message/video-message.vue')
  },
  {
    path: 'video-message/:id',
    component: require('./pages/video-message/video-message-details.vue')
  },
  {
    path: 'edit-user-profile',
    component: require('./pages/edit-user-profile.vue')
  },
  {
    path: 'about-company',
    component: require('./pages/about/about-company.vue')
  },
  {
    path: '/notifications',
    component: require('./pages/notifications.vue')
  },
  {
    path: `/${PAGES.RacommendAFriend}`,
    component: require('./pages/referral-program/recommend-friend.vue')
  },
  {
    path: `/${PAGES.RacommendAFriend}/${PAGES.Referrals}`,
    component: require('./pages/referral-program/recommend-friend-history.vue')
  },
  {
    path: `/${PAGES.RacommendAFriend}/${PAGES.ReferralHowItWorks}`,
    component: require('./pages/referral-program/how-it-works.vue')
  },
  {
    path: '/error',
    component: require('./pages/error.vue')
  },
  {
    path: '/calc',
    component: require('./pages/calc.vue')
  },
  {
    path: '/card',
    component: require('./pages/card.vue')
  },
  {
    path: `/${PAGES.Inventory}`,
    component: require('./pages/inventory/inventory.vue')
  },
  {
    path: '/specials',
    component: require('./pages/inventory/specials.vue')
  },
  {
    path: '/owner-manual',
    component: require('./pages/ownermanual.vue')
  },
  {
    path: `${PAGES.Inventory}/filter`,
    component: require('./pages/inventory/dealertrend-filter-mobile.vue')
  },
  {
    path: '/vehicle/:id',
    component: require('./pages/inventory/vehicle.vue')
  },
  {
    path: '/vehicale-gallery/:id',
    component: require('./pages/inventory/vehicle-gallery.vue')
  },
  {
    path: '/about-us',
    component: require('./pages/about/about-us.vue')
  },
  {
    path: '/garage',
    component: require('./pages/garage/garage.vue')
  },
  {
    path: `/${PAGES.GaragePurchased}`,
    component: require('./pages/garage/garage.vue')
  },
  {
    path: `/${PAGES.GarageFavorites}`,
    component: require('./pages/garage/garage.vue')
  },
  {
    path: '/contact',
    component: require('./pages/contact/contact.vue')
  },
  {
    path: `/${PAGES.DeletedDealer}`,
    component: require('./pages/deleted/deleted-dealer.vue')
  },
  {
    path: `/${PAGES.DeletedSalesperson}`,
    component: require('./pages/deleted/deleted-salesperson.vue')
  },
  {
    path: PAGES.Reassigned,
    component: require('./pages/deleted/reassigned.vue')
  },
  {
    path: '/401',
    component: require('./pages/401.vue')
  },
  {
    path: ':tokenId/',
    component: require('./pages/home/index.page.vue')
  }
]



// WEBPACK FOOTER //
// ./scripts/src/routes.js